import * as React from 'react';

import * as style from './GroupTitleField.css';

export const GroupTitleField: React.FC<React.PropsWithChildren<{}>> = props => {
  const { children } = props;

  return <div className={style['container']}>{children}</div>;
};
